import { Action } from 'redux';
import * as _ from 'underscore';

import { UserNotificationState } from '../../app/state/UserNotificationState';
import { NotificationDisplayMode } from '../components/NotificationPanel';
import { isCheckHasUnseenUserNotificationsSucceededAction } from './actions/CheckHasUnseenUserNotificationsAction';
import { isClearUserNotificationsStateAction } from './actions/ClearUserNotificationsStateAction';
import { isDeleteUserNotificationSucceedAction } from './actions/DeleteUserNotification';
import { isGetUserNotificationsFailedAction,isGetUserNotificationsSucceededAction } from './actions/GetUserNotificationsAction';
import { isUpdateLastSeenUserNotificationSucceededAction } from './actions/UpdateLastSeenUserNotificationAction';
import { isUpdateUserNotificationsStatusSucceedAction } from './actions/UpdateUserNotificationStatusAction';


const initialState: UserNotificationState = {
  nextPageToken: null,
  hasUnseenNotifications: false,
  notifications: null,
  notificationDisplayMode: NotificationDisplayMode.NotificationLoading
};

export function userNotificationsReducer(
  prevState: UserNotificationState = initialState,
  action: Action = null
): UserNotificationState {
  if (isGetUserNotificationsSucceededAction(action)) {
    return {
      nextPageToken: action.nextPageToken,
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: Object.assign({}, prevState.notifications, action.notifications),
      notificationDisplayMode: NotificationDisplayMode.NotificationLoaded
    };
  } else if (isUpdateUserNotificationsStatusSucceedAction(action)) {
    const { notifications} = prevState;
    _.forEach(action.notificationIds, (id: string) => {
      notifications[id].read = action.isRead;
    });
    return {
      nextPageToken: prevState.nextPageToken,
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: _.clone(notifications),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isDeleteUserNotificationSucceedAction(action)) {
    return {
      nextPageToken: prevState.nextPageToken,
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: _.omit(prevState.notifications, action.notificationId),
      notificationDisplayMode: prevState.notificationDisplayMode
    };
  } else if (isCheckHasUnseenUserNotificationsSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: action.hasUnseenUserNotifications,
    };
  } else if (isUpdateLastSeenUserNotificationSucceededAction(action)) {
    return {
      ...prevState,
      hasUnseenNotifications: false
    };
  } else if (isGetUserNotificationsFailedAction(action)) {
    return {
      nextPageToken: prevState.nextPageToken,
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: prevState.notifications,
      notificationDisplayMode: NotificationDisplayMode.NotificationLoadFailed
    };
  } else if (isClearUserNotificationsStateAction(action)) {
    return {
      nextPageToken: null,
      hasUnseenNotifications: prevState.hasUnseenNotifications,
      notifications: {},
      notificationDisplayMode: NotificationDisplayMode.NotificationLoading
    };
  } else {
    return prevState;
  }
}
